import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";
import RecordDialog from "../components/RecordDialog";
import DumperInspectionDialog from "../components/DumperInspectionDialog";
import PhotoGallery from "../components/PhotoGallery";
import { Button } from "../components/ui/button";
import { StatusBadge } from "../components/StatusBadge";
import { Plus, ClipboardText } from "@phosphor-icons/react";

export default function Inspections() {
  const navigate = useNavigate();
  const { currentSite } = useAuth();
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/inspections").then(({ data }) => setRows(data));
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <div className="overline text-amber-500 flex items-center gap-2"><ClipboardText size={14} /> Periodic Checks</div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">Tyre Inspections</h1>
        </div>
        <Button data-testid="add-inspection-btn" onClick={() => setOpen(true)} className="bg-amber-500 font-bold text-zinc-950 hover:bg-amber-400">
          <Plus size={16} weight="bold" className="mr-1" /> New Inspection
        </Button>
      </div>

      <div className="overflow-x-auto rounded-sm border border-zinc-800">
        <table className="w-full min-w-[680px] text-sm">
          <thead className="bg-zinc-900 text-left overline text-zinc-500">
            <tr>
              <th className="px-4 py-3">Tyre</th><th className="px-4 py-3">Tread</th>
              <th className="px-4 py-3">Pressure</th><th className="px-4 py-3">Condition</th>
              <th className="px-4 py-3">Recommended</th><th className="px-4 py-3">Photos</th><th className="px-4 py-3">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800">
            {rows.map((r) => (
              <tr key={r.id} data-testid={`inspection-row-${r.id}`} onClick={() => navigate(`/tyres/${r.tyre_id}`)} className="cursor-pointer bg-zinc-950 hover:bg-zinc-900">
                <td className="px-4 py-3 font-mono font-bold text-amber-500">{r.serial_number}</td>
                <td className="px-4 py-3 tabular-nums">{r.tread_depth}mm</td>
                <td className="px-4 py-3 tabular-nums">{r.pressure || "—"}</td>
                <td className="px-4 py-3 text-zinc-400">{r.overall_condition || "—"}</td>
                <td className="px-4 py-3"><StatusBadge status={["Remove", "Scrap"].includes(r.recommended_action) ? "high" : r.recommended_action === "Monitor" ? "medium" : "low"} testid={`insp-action-${r.id}`} /> <span className="ml-1 text-zinc-400">{r.recommended_action}</span></td>
                <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}><PhotoGallery photos={r.photos || []} thumb="h-10 w-10" testid={`inspection-photo-${r.id}`} /></td>
                <td className="px-4 py-3 text-zinc-500">{new Date(r.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-8 text-center text-zinc-500">No inspections</td></tr>}
          </tbody>
        </table>
      </div>

      {open && <DumperInspectionDialog open={open} siteId={currentSite?.id} onOpenChange={setOpen} onDone={load} />}
    </div>
  );
}
